import instance from "./instance";

const ReportAPINew = (params) => {
  return instance.get(`/reports?${params}`,
  {
    headers: {
      "Content-Language": localStorage.getItem('i18nextLng'),
    },
  });
};

export default ReportAPINew;
